import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const OrderBy = props => {
  function handleOrderChoice(e) {
    props.onSelectOrder(e.target.value)
  }

  return (
    <div className="c-shop-select-filter">
      <select
        value={props.order}
        onChange={handleOrderChoice}
        disabled={props.postsLoading}
        className="c-shop-select-filter__select"
      >
        <option value="">Sort by</option>
        <option value="title_asc">Brand (a-z)</option>
        <option value="title_desc">Brand (z-a)</option>
      </select>
    </div>
  )
}

export default OrderBy


// WEBPACK FOOTER //
// ./src/js/shop/components/Orderby.js